import React, { useEffect, useState } from "react";
import { Grid, Card, Box, Button, Dialog } from "@mui/material";

import { toast } from "react-toastify";

import { TCInput } from "components/TopCourtComponents/Input/TopCourtInput";
import { TCLabel } from "components/TopCourtComponents/Label/TopCourtLabel";
import TableComponent from "components/TopCourtComponents/Table/TableComponent";

import { updateUserServiceRole, createUserServiceRole, getUsers } from "services/userServices";
import { IconX } from "@tabler/icons";
import moment from "moment";
import { serviceRole } from "constant/constant";
import SetServiceRoleDialog from "views/pages/merchant/component/dialog/setServiceRoleDialog";

function CourtAdmin({
    placeId,
    merchantCode
}) {
    console.log('here placeId', placeId)
    return (
        <Card sx={{ padding: 2, borderTopLeftRadius: 0, borderTopRightRadius: 0 }} onClick={() => {
            // navigate(`/player/${value._id}`)
        }}>
            {/* <Admins partnerId={merchantId} merchantId={placeId} partnerCode={merchantCode} /> */}
            {/* Ini mau buat form untuk crate akun Tab atau akun */}
            <ServiceAssignmentPage placeId={placeId} />
        </Card>
    )
}

const initFilter = {
    phoneNumber: "",
    page: 0,
    limit: 20,
};

function ServiceAssignmentPage({
    placeId
}) {
    const [filter, setFilter] = useState(initFilter);
    const [isLoading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [totalData, setTotalData] = useState(0);
    const [dialog, setDialog] = useState({ open: false, data: null });
    const [rejectDialog, setRejectDialog] = useState({ open: false, data: null })
    const sanitizePhone = (v) => (v || "").replace(/[^\d]/g, "");

    useEffect(() => {
        if (filter === initFilter) {
            loadData()
        }
    }, [filter])

    const validatePhoneNumber = () => {
        const phone = sanitizePhone(filter.phoneNumber);
        if (!phone) {
            toast.warning("Phone number is required");
            return false;
        } else {
            handleSearch(phone)
        }
    }

    const handleSearch = async (phone) => {
        try {
            setLoading(true);
            let { data, error } = await createUserServiceRole({
                placeId: placeId,
                phoneNumber: phone
            })
            setLoading(false)
            if (error) {
                toast.error(error.message)
            }
            if (data) {
                toast.success('User added')
                setFilter({ phoneNumber: '' })
                loadData()
            }
        } catch (error) {
            console.error(error);
        }
    }

    const loadData = async () => {
        try {
            setLoading(true);
            let { data, error } = await getUsers({
                placeId: placeId,
                phoneNumber: filter.phoneNumber.replace('+', '').replace(/^08/g, '628') || '',
                page: filter.page,
                limit: filter.limit
            });
            setLoading(false)
            if (error) { throw error }
            if (data) {
                setRows(data.items || []);
                setTotalData(data.totalData || 0);
            }
        } catch (e) {
            console.error(e);
            toast.error("Failed to search user");
        } finally {
            setLoading(false);
        }
    };

    const deleteRole = async (userId) => {
        try {
            const { data, error } = await updateUserServiceRole({
                _id: userId,
                placeId
            });
            if (error) throw error;
            if (data) {
                toast.success("Service role removed");
                loadData()
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to remove role");
        }
    };

    const valueCustomator = (row) => {
        return {
            phoneNumber: (
                <span
                    className="span-link"
                    onClick={() => setDialog({ open: true, data: row })}
                >
                    {row.phoneNumber}
                </span>
            ),
            name: <TCLabel>{row.verifyId ? row.verifyId.idName : row.name || "-"}</TCLabel>,
            //TODO: set username from BE
            username: <TCLabel>{row.name || "-"}</TCLabel>,
            serviceRole: <TCLabel>{serviceRole(row.isCounter, row.isStaff)}</TCLabel>,
            status: (
                <TCLabel>
                    {row.serviceActive ? "Active" : "Inactive"}
                </TCLabel>
            ),
            updatedAt: <TCLabel>{row.updatedDate ? moment(row.updatedDate).format("YYYY/MM/DD HH:mm:ss") : "-"}</TCLabel>,
            action: <div>
                <Grid container spacing={1}>
                    <Grid item>
                        <Button variant='contained' style={{
                            backgroundColor: '#E35480'
                        }} onClick={() => {
                            // deleteRole(row._id)
                            setRejectDialog({open: true, data: {id: row._id, name: row.name} })
                        }}><IconX size={15} /></Button>
                    </Grid>
                </Grid>
            </div>
        };
    };

    return (
        <>
            <Box sx={{ p: 2 }}>
                {/* Search area */}
                <Grid container spacing={2} alignItems="center" mb={2}>
                    <Grid item xs={8} md={4}>
                        <TCInput
                            fullWidth
                            label="Phone Number (Add-On, Counter, Staff)"
                            value={filter.phoneNumber}
                            onChange={(e) => {
                                let phoneNumber = e.currentTarget.value.replace(/[^0-9]/g, "")
                                if (filter.phoneNumber == phoneNumber) { return; }
                                setFilter((prev) => ({
                                    ...prev,
                                    phoneNumber: phoneNumber,
                                }))
                            }}
                            placeholder="08123456789"
                        />
                    </Grid>

                    <Grid item md="auto" mt={2} >
                        <Box display={"flex"} alignItems={"center"} gap={2}>
                            <Button
                                variant="contained"
                                onClick={() => { validatePhoneNumber() }}
                                disabled={isLoading}
                            >
                                {isLoading ? "Searching..." : "Search"}
                            </Button>
                            <Button sx={{ border: '0.5px solid #2196f3', borderRadius: 4 }}
                                onClick={() => {
                                    setFilter(initFilter);
                                }}
                            >
                                Clear
                            </Button>
                        </Box>
                    </Grid>
                </Grid>

                {/* <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2}
                >
                    <Box>
                        <Typography variant="body2" color="text.secondary">
                            Search user by phone number and assign service role (Counter and Staff).
                        </Typography>
                    </Box>
                </Box> */}

                {/* Result Table */}
                <TableComponent
                    columns={[
                        { label: "Phone" },
                        { label: "Name" },
                        { label: "Username" },
                        { label: "Service Role" },
                        { label: "Status" },
                        { label: "Updated" },
                        { label: '' }
                    ]}
                    rows={rows}
                    valueCustomator={valueCustomator}
                    pageChange={(p) => setFilter((prev) => ({ ...prev, page: p }))}
                    loading={isLoading}
                    totalData={totalData}
                    page={filter.page}
                />
                <Dialog open={rejectDialog.open} onClose={() => {
                    setRejectDialog({ open: false, data: null })
                }}>
                    <Card>
                        <Grid sx={{ p: 3 }}>
                            <Grid pb={1}>
                                <TCLabel>Are you sure want to remove <span style={{ fontWeight: 'bold' }}>{rejectDialog.data?.name || ''}</span> ?</TCLabel>
                            </Grid>
                            <Grid container xs={12} spacing={1} pt={1} justifyContent={"right"}>
                                <Grid item>
                                    <Button onClick={() => {
                                        setRejectDialog(false)
                                    }}>Cancel</Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        variant='contained'
                                        style={{ backgroundColor: '#E35480' }}
                                        onClick={() => {
                                            if (rejectDialog.data.id) {
                                                setRejectDialog({ open: false, data: null })
                                                deleteRole(rejectDialog.data.id)
                                            }
                                        }}
                                    >
                                        Remove
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Card>
                </Dialog>
            </Box>

            {/* Dialog for set role */}
            <SetServiceRoleDialog
                placeId={placeId}
                setDialog={dialog}
                handleClose={(isUpdated) => {
                    setDialog({ open: false, data: null });
                    // reload search results to reflect updates
                    if (isUpdated === true) loadData();
                }}
            />
        </>
    );
}


export default CourtAdmin